import { render, staticRenderFns } from "./createFile.vue?vue&type=template&id=561ed541&"
import script from "./createFile.vue?vue&type=script&lang=js&"
export * from "./createFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports